<template lang="pug">
.question_stripe.d-flex.flex-column
  .title_btn.d-flex.align-items-center.justify-content-between.i_mr_16.i_mr_sm_0
    h5.i_body.i_mt_3 {{ question.FAQTitle }}
    svg-icon.d-md-none(
      iconClass="arrow_bottom_g",
      className="arrow_bottom_g",
      :class="{ expand: isExpand }"
    )
    .question_title_cover.d-none.d-md-block
  .divider.i_mt-3
  p.i_mt_4.i_mr_16.i_mr_sm_0 {{ question.FAQBrief }}
  .see_more_btn.d-none.d-md-block.i_mlr_0.text-right(@click="toDetail") 看更多
  hr
</template>

<script>
export default {
  name: "QuestionStripe",
  components: {},
  props: {
    question: Object,
    selected: Boolean,
  },
  methods: {
    toDetail() {
      this.$router.push({
        name: "CustomerServiceFAQDetail",
        query: { id: this.question.FAQID },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/question_stripe";
</style>
